import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../components/Reveal';
import ClayIcon from '../components/site/ClayIcon';
import './Rates.css';

function Rates() {
  const { t } = useTranslation();
  const routes = t('rates.routes', { returnObjects: true });

  return (
    <div className="rates-page">
      {/* Header */}
      <section className="rates-header hero-band hero-band-photo" style={{ '--card-photo': 'url(/images/taxiready2go-photos/two-taxis-hotel-banner.jpg)' }}>
        <div className="container">
          <h1>{t('rates.header.title')}</h1>
          <p>{t('rates.header.subtitle')}</p>
        </div>
      </section>

      {/* Rates Table */}
      <section className="rates-section">
        <div className="container">
          <div className="rates-table list-card">
            {routes.map((route, index) => (
              <Reveal key={index} className="rate-row list-row" delay={index * 60}>
                <div className="rate-route-group">
                  <ClayIcon name={index === 0 ? 'plane' : 'car'} size={48} />
                  <span className="rate-route">{route.route}</span>
                </div>
                <span className="rate-price">{route.price}</span>
              </Reveal>
            ))}
          </div>
          <p className="rates-note">{t('rates.note')}</p>
        </div>
      </section>

      {/* CTA */}
      <section className="rates-cta hero-band hero-band-photo" style={{ '--card-photo': 'url(/images/taxiready2go-photos/fleet-three-taxis-banner.jpg)' }}>
        <div className="container">
          <h2>{t('rates.cta.title')}</h2>
          <p>{t('rates.cta.subtitle')}</p>
          <Link to="/#book" className="btn btn-primary btn-large">{t('rates.cta.bookNow')}</Link>
        </div>
      </section>
    </div>
  );
}

export default Rates;
